import { ReactNode } from 'react';
import styles from './IconButton.module.css';

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
}

const IconButton = ({ icon, ...props }: IconButtonProps): JSX.Element => {
  return (
    <button {...props} className={styles.iconButton}>
      <div className={styles.icon}>{icon}</div>
    </button>
  );
};

export default IconButton;
